/* eslint-disable import/no-extraneous-dependencies */
import Odometer from 'odometer';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

class AnimatedFactsNumber {
  constructor(el) {
    this.el = el;
  }

  init() {
    this.setOdometer();
    this.setTrigger();
  }

  setOdometer() {
    this.od = new Odometer({
      el: this.el,
      value: 0,
      format: '(.ddd),dd',
    });
  }

  setTrigger() {
    gsap.to(this.el, {
      scrollTrigger: {
        trigger: this.el,
        once: true,
        start: 'top bottom',
        onEnter: () => {
          this.updateOdometerValue();
        },
      },
    });
  }

  updateOdometerValue() {
    this.od.update(this.el.dataset.value);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const AnimatedFactsNumbers = document.querySelectorAll('.animated-facts-numbers .number');

  AnimatedFactsNumbers.forEach((el) => {
    new AnimatedFactsNumber(el).init();
  });
});
